import { render, staticRenderFns } from "./HeaderCustomerMenu.vue?vue&type=template&id=f33cce3e"
import script from "./HeaderCustomerMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderCustomerMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports